var _style, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDanger(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "danger_svg__Icon_-_Danger",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 24 24",
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".danger_svg__st1{fill:none;stroke:currentColor;stroke-width:1.5;stroke-linecap:round;stroke-linejoin:round}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "danger_svg__Group_1716"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "danger_svg__Ellipse_283",
    className: "danger_svg__st1",
    cx: 12,
    cy: 12,
    r: 11.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "danger_svg__Line_648",
    className: "danger_svg__st1",
    d: "M7.5 16.5l9-9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "danger_svg__Line_649",
    className: "danger_svg__st1",
    d: "M16.5 16.5l-9-9"
  }))));
}
export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDI1LjQuMSwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9Ikljb25fLV9EYW5nZXIiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIKCSB5PSIwcHgiIHZpZXdCb3g9IjAgMCAyNCAyNCIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgMjQgMjQ7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4KPHN0eWxlIHR5cGU9InRleHQvY3NzIj4KCS5zdDB7ZmlsbDpub25lO30KCS5zdDF7ZmlsbDpub25lO3N0cm9rZTpjdXJyZW50Q29sb3I7c3Ryb2tlLXdpZHRoOjEuNTtzdHJva2UtbGluZWNhcDpyb3VuZDtzdHJva2UtbGluZWpvaW46cm91bmQ7fQo8L3N0eWxlPgo8cmVjdCB4PSIwIiB5PSIwIiBjbGFzcz0ic3QwIiB3aWR0aD0iMjQiIGhlaWdodD0iMjQiLz4KPGcgaWQ9Ikdyb3VwXzE3MTYiPgoJPGNpcmNsZSBpZD0iRWxsaXBzZV8yODMiIGNsYXNzPSJzdDEiIGN4PSIxMiIgY3k9IjEyIiByPSIxMS4yIi8+Cgk8bGluZSBpZD0iTGluZV82NDgiIGNsYXNzPSJzdDEiIHgxPSI3LjUiIHkxPSIxNi41IiB4Mj0iMTYuNSIgeTI9IjcuNSIvPgoJPGxpbmUgaWQ9IkxpbmVfNjQ5IiBjbGFzcz0ic3QxIiB4MT0iMTYuNSIgeTE9IjE2LjUiIHgyPSI3LjUiIHkyPSI3LjUiLz4KPC9nPgo8L3N2Zz4K";
export { SvgDanger as ReactComponent };